<template>
  <organism-use-config-template
    v-if="!isLoading"
    :id="id"
    :templateDetail="templateDetail"
    :generateConfig="generateConfig"
    @clickGenerate="clickGenerateToApi"
  ></organism-use-config-template>
</template>

<script>
import { getTemplateById, generateTemplate } from "@/api/api-module4"
import mixins from "@/mixins"
import OrganismUseConfigTemplate from "@/components/organisms/networkConfigurationManagement/configurationTemplate/OrganismUseConfigTemplate.vue"

export default {
  name: "UseConfigTemplate",
  components: {
    OrganismUseConfigTemplate,
  },
  mixins: [mixins],
  data() {
    return {
      templateDetail: null,

      generateConfig: null,
    }
  },
  async created() {
    await this.getDataFromApi()
  },
  computed: {
    isLoading() {
      return !this.templateDetail
    },
    id() {
      return this.$route?.params?.id
    },
  },
  methods: {
    async getDataFromApi() {
      this.showLoading(true)
      await getTemplateById(this.id)
        .then((template) => {
          const parameters = []
          template.configTemplateParameters.forEach((parameter) => {
            parameters.push({
              parameterName: parameter.key,
              value: parameter.value,
            })
          })

          this.templateDetail = {
            id: template.configTemplateId,
            templateName: template.configTemplateName,
            tags: template.tags,
            description: template.configTemplateDescription,
            parameters,
          }
        })
        .finally(() => this.showLoading(false))
    },

    async clickGenerateToApi(configTemplateParameters) {
      this.showLoading(true)
      await generateTemplate(this.id, configTemplateParameters)
        .then((response) => {
          this.generateConfig = response.data
        })
        .finally(() => this.showLoading(false))
    },
  },
}
</script>

<style lang="scss" scoped></style>
